import { render } from "./MaterialsTable.vue?vue&type=template&id=5f18f6c2&scoped=true&lang=pug"
import script from "./MaterialsTable.vue?vue&type=script&lang=ts"
export * from "./MaterialsTable.vue?vue&type=script&lang=ts"

import "./MaterialsTable.vue?vue&type=style&index=0&id=5f18f6c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f18f6c2"

export default script